import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
// import { RowInput, RowOutput } from './_PowerCalculationJIS';
import { Input, Output, Select, Wrapper, Label, Variable, Unit, InputBlock, StyledSelect } from '../common/SingleInput';

import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';

import { nylonBelt, polyesterBelt, steelCordBelt } from '../../../lib/data/belt-data-new';

import { minPulleyDiaForFabric, minPulleyDiaForSteelcord } from '../../../lib/data/pulley-data-new';
import { toFixedSafe } from '../../../lib/styles/perttierNumber';

const BeltForm = (props) => {
    const dispatch = useDispatch();

    const input = useSelector((state) => state.conveyorWrite.body.input);
    const output = useSelector((state) => state.conveyorWrite.body.output);
    const drives = useSelector((state) => state.conveyorWrite.body.drives);
    const prevBelt = useSelector((state) => state.conveyorWrite.body.belt);

    const { carcassType, beltWidth, length: horizontalLength } = input;
    const { massBelt, slopeAngle } = output;

    useEffect(() => {
        if (!drives || !Array.isArray(drives)) {
            return;
        }

        const maxTension = drives[0]?.tightSideTension?.load;

        setBelt((prev) => ({
            ...prev,
            maxTension,
        }));
    }, [drives]);

    const BW = parseFloat(beltWidth) / 1000; // m로 환산

    const [belt, setBelt] = useState(prevBelt || {});
    const [beltCategory, setBeltCategory] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBelt((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        const beltCategory = carcassType === 'ST' ? steelCordBelt : carcassType === 'EP' ? polyesterBelt : nylonBelt;
        const safetyFactor = carcassType === 'ST' ? 7 : 12;
        setBelt((prev) => ({
            ...prev,
            safetyFactor,
        }));
        setBeltCategory(beltCategory);
    }, [carcassType]);

    const handleBeltSelection = (e) => {
        const { value } = e.target;
        const selected = beltCategory.find((belt) => belt.label === value);

        setBelt((prev) => ({
            ...prev,
            minPulleyDia: selected.minPulleyDia || '',
            plyNumber: selected.plyNumber || '',
            plyThickness: selected.plyThickness || '',
            plyWeight: selected.plyWeight || '',
            strength: selected.strength || '',
            selectedBelt: selected.label || '',
            cordDia: selected.cordDia || '',
            cordPitch: selected.cordPitch || '',
            cordWeight: selected.cordWeight || '',
            numberOfStep: selected.numberOfStep || '',
        }));
    };

    /* Safefy Factor를 handleBeltSelection에서하면 값이 변경되었을 때 반영되지 않는다. */
    useEffect(() => {
        const _actualBeltSF = Number(belt.strength) / (Number(belt.maxTension) / Number(beltWidth))

        const isSafe = _actualBeltSF / Number(belt.safetyFactor) < 1 ? false : true;

        setBelt((prev) => ({
            ...prev,
            actualBeltSF: Math.ceil(_actualBeltSF * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [belt.maxTension, belt.safetyFactor, belt.strength, beltWidth]);


    /* Unit Belt Tension */
    useEffect(() => {
        const unitBeltTension = (belt.maxTension * belt.safetyFactor) / BW / 1000; // kN/m
        setBelt((prev) => ({
            ...prev,
            unitBeltTension: Math.ceil(unitBeltTension),
        }));
    }, [BW, belt.maxTension, belt.safetyFactor]);

    /* Actual Safety Factor */
    /* 여기서 하면 상부에서 뭔가 바뀌었을 때 잘못된 숫자가 나와있어 사용자를 헷갈리게 할 수 있다. 벨트를 선택했을 때 나오도록 handleBeltSelection으로 이동
    useEffect(() => {
        const _actualBeltSF = belt.strength / (belt.maxTension / 1000 / BW);
        setBelt(prev => ({
            ...prev,
            actualBeltSF: Math.round(_actualBeltSF * 10) / 10,
        }))
    }, [BW, belt.maxTension, belt.strength]);
    */

    /* 벨트 길이 및 중량 산정 */
    useEffect(() => {
        /** 1) horizontalLength, 각도를 가지고 전체 길이를 산정하고 ( horizontalLength / cos(theta)로 하면 정확하지는 않지만 Acceptable하다.)
         *  2) Spling Length를 every 150m 마다 1 point로 벨트폭 x 2
         *  3) take-up을 위해 전체 길이에 대해 신율 (NN 3%, EP1%, ST 0.3%) + 작업 여유를 위해 벨트폭 x 3
         *  4) 그냥 여유로 1% Up */

        const elongation = carcassType === 'ST' ? 0.003 : 0.03;

        const baseLength = Math.ceil((2 * horizontalLength) / Math.cos((slopeAngle * Math.PI) / 180));
        const forSplicing = Math.ceil(Math.ceil(baseLength / 150) * 2 * BW);
        const forTakeup = Math.ceil(baseLength * elongation + 3 * BW);
        const _tapeLength = (baseLength + forSplicing + forTakeup) * 1.01;

        setBelt((prev) => ({
            ...prev,
            tapeLength: Math.ceil(_tapeLength),
            weight: Math.ceil(_tapeLength * massBelt),
        }));
    }, [BW, carcassType, horizontalLength, massBelt, slopeAngle]);

    const CTr = useRef({
        NN: 80,
        EP: 108,
        ST: 145,
    });

    /* 최소 풀리 직경 */
    useEffect(() => {
        if (!carcassType || !belt.strength || !belt.unitBeltTension) return;
        const loadFactor = (belt.strength / belt.unitBeltTension) * 100;
        let minPulleyDia = [];
        if (carcassType !== 'ST') {
            const DTr = belt.plyThickness * CTr.current[carcassType];
            minPulleyDia = findMinDiaForFabricBelt(DTr, loadFactor);
        } else {
            minPulleyDia = findMinDiaForSteelcordBelt(belt.strength, loadFactor);
        }

        setBelt((prev) => ({
            ...prev,
            minPulleyDia,
        }));
    }, [belt.plyThickness, belt.strength, belt.unitBeltTension, carcassType]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'belt',
                value: belt,
            }),
        );
    }, [belt, dispatch]);

    return (
        <BeltFormBlock>
            <Title>
                <h3>Belt Selection</h3>
            </Title>
            <Content>
                <Output
                    label="Max. Tension in Belt"
                    variable="-"
                    variableName="maxTension"
                    unit="-"
                    value={belt.maxTension}
                />
                <Output
                    label="Min. Safety Factor"
                    variable="SF"
                    variableName="safetyFactor"
                    unit="-"
                    value={belt.safetyFactor}
                />
                <Output
                    label="Required Belt Tension per meter in Belt Width"
                    variable="KNW"
                    variableName="KNW"
                    unit="kN/m"
                    value={belt.unitBeltTension}
                />
                <Input
                    label="Top Cover Thickness"
                    variable="-"
                    unit="mm"
                    variableName="topCoverThick"
                    value={belt.topCoverThick}
                    onChange={handleChange}
                />
                <Input
                    label="Bottom Cover Thickness"
                    variable="-"
                    unit="mm"
                    variableName="bottomCoverThick"
                    value={belt.bottomCoverThick}
                    onChange={handleChange}
                />
                <SelectBelt
                    label="Belt Selected"
                    variable="-"
                    variableName="selectedBelt"
                    unit="-"
                    value={belt.selectedBelt}
                    options={beltCategory || []}
                    onChange={handleBeltSelection}
                    carcassType={carcassType}
                    isRequired
                />
                <Output
                    label="Actual Belt Safety Factor"
                    variable="-"
                    unit="-"
                    variableName="actualBeltSF"
                    value={toFixedSafe(belt.actualBeltSF?.toFixed(1), 1)}
                    isSafe={belt.isSafe}
                />
            </Content>
        </BeltFormBlock>
    );
};

export default BeltForm;

/* =================   Styles   ================== */

const BeltFormBlock = styled.div``;
const Title = styled.div``;
const Content = styled.div``;


export const RowSelectBelt = ({
    label,
    variable,
    unit,
    variableName,
    value,
    options,
    carcassType,
    handleChange,
    isRequired,
}) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', minWidth: '500px', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={{ textAlign: 'right', color: `${palette.gray[6]}` }}>-</td>
            <td style={{ width: '100px' }}>
                <Select name={variableName} value={value} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item, index) => {
                        return (
                            <option key={index} value={item.label}>
                                {item.label}
                            </option>
                        );
                    })}
                </Select>
            </td>
            <td>-</td>
        </tr>
    );
};

const SelectBelt = ({ label, variable, unit, variableName, value, options, carcassType, onChange, isRequired }) => {
    return (
        <Wrapper>
            <Label>{label}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                <StyledSelect name={variableName} value={value} onChange={onChange} isRequired={isRequired}>
                    <option value="" selected disabled hidden>
                        Select...
                    </option>
                    {options.map((item, index) => (
                        <option key={index} value={item.label}>
                            {item.label}
                        </option>
                    ))}
                </StyledSelect>
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};

// const Select = styled.select`
//     width: 100%;
//     border: none;
//     outline: none;
//     padding: 0.25rem 0;
//     text-align: center;
//     background-color: ${palette.cyan[0]};
//     ${(props) =>
//         props.isRequired &&
//         css`
//             background-color: ${palette.yachtBlue};
//             color: white;
//         `}
// `;

const findMinDiaForFabricBelt = (value, loadFactor) => {
    // loadFactor를 기준으로 카테고리 설정
    let loadCategory;
    if (loadFactor >= 60) {
        loadCategory = '100%';
    } else if (loadFactor >= 30) {
        loadCategory = '60%';
    } else {
        loadCategory = '30%';
    }

    // 주어진 DTr Value보다 크거나 같은 최소 DTr 또는 rating을 갖는 값을 찾는다.
    const suitableEntry = minPulleyDiaForFabric.find((data) => data.DTr >= value);

    if (!suitableEntry) {
        // throw new Error('적합한 값이 데이터에 없습니다.');
        return;
    }

    // 해당 loadFactor와 group에 맞는 최소 풀리 직경을 반환한다.
    return suitableEntry.loadFactors[loadCategory];
};

const findMinDiaForSteelcordBelt = (value, loadFactor) => {
    // loadFactor를 기준으로 카테고리 설정
    let loadCategory;
    if (loadFactor >= 60) {
        loadCategory = '100%';
    } else if (loadFactor >= 30) {
        loadCategory = '60%';
    } else {
        loadCategory = '30%';
    }

    // 주어진 DTr Value보다 크거나 같은 최소 DTr 또는 rating을 갖는 값을 찾는다.
    const suitableEntry = minPulleyDiaForSteelcord.find((data) => data.rating >= value);

    if (!suitableEntry) {
        // throw new Error('적합한 값이 데이터에 없습니다.');
        return;
    }

    // 해당 loadFactor와 group에 맞는 최소 풀리 직경을 반환한다.
    return suitableEntry.loadFactors[loadCategory];
};
